module.exports = __webpack_public_path__ + "img/b5-5.7c53796.png";